module.exports = __webpack_public_path__ + "static/media/user-avt.9a9672bf.svg";